<mat-slide-toggle
  [checked]="currentValue()"
  [disabled]="isDisabled()"
  [name]="nameAttribute()"
  (change)="onChangeValue($event)"
  >{{ label() | resolveTranslateAbleText }}
</mat-slide-toggle>
